export type DisciplineType = 'PT' | 'OT' | 'ST' | 'SN' | 'MSW' | 'HHA';

/**
 * Array of all DisciplineType values.
 */
export const DISCIPLINETYPE_VALUES: readonly DisciplineType[] = [
  'PT',
  'OT',
  'ST',
  'SN',
  'MSW',
  'HHA',
] as const;
